<div class="content">
  <div class="d-flex flex-row align-items-center mb-3">
    <span>Are you sure you want to delete the following borrower(s)? This action cannot be undone if you continue.</span>
  </div>
  <div class="d-flex flex-column align-items-start">
    <span class="bold">Borrower(s):</span>
    <ul id="deleted-borrowers-list">
      @for (borrowerName of borrowerNames; track borrowerName) {
        <li>{{ borrowerName }}</li>
      }
    </ul>
  </div>
</div>
<div class="dialog-button-container">
  <button pButton type="button" severity="secondary" (click)="reject()">No, Cancel</button>
  <button pButton type="button" (click)="accept()">Yes, Continue</button>
</div>
